import React from "react";
import Button from "../../../components/Common/Button/button";
import styles from "../../LKWallet/EmployeeCredit/lkemployeecredit.module.css";
import TableActions from "../../../components/Common/TableActions/tableactions";
import moment from "moment";
import {
  PageHeader,
  Input,
  Row,
  Col,
  Select,
  Form,
  Space,
  Spin,
  // Popconfirm,
  Table,
  Modal,
  // Checkbox,
  notification,
  // DatePicker,
  Upload,
  Tooltip,
} from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faChevronUp,
  faInfo,
  faDownload,
  // faPencilAlt,
  // faTrash,
} from "@fortawesome/free-solid-svg-icons";
import LKCustomerBulkCreditService from "../../../services/lkcustomerbulkcreditservice";
import { IsAuthenticated } from "../../../services/auth-header";
import UserRightsConfiguration from "../../../shared/userrightsconfiguration";
import { UploadOutlined } from "@ant-design/icons";
import ReactExport from "react-export-excel";
import { labels } from "../../../shared/language";
import Common from "../../../services/common";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
const { Search } = Input;
const { Option } = Select;

export default class Customerbulkcredit extends React.Component {
  constructor(props) {
    super(props);
    this.customerbulkCreditService = new LKCustomerBulkCreditService();
    this.UserRightsConfiguration = new UserRightsConfiguration();
    this.common = new Common();
    this.state = {
      modalLoading: false,
      excelFile: <React.Fragment></React.Fragment>,
     
      lkCustomerBulkCreditItems:[],
      custCreditFileID: 0,
      fileName: "",
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
      },
      isEnabled: false,
      isVisible: false,
      loading: true,
      showfilterBox: false,
      showAddPopup: false,
      showSinglePopup: false,

      uploading: false,
      fileList: [],
      binaryFile: "",
      currentURL: "",
      EmployeeCreditDetailsList: [],
    };
  }

  componentWillMount() {
    if (!IsAuthenticated()) {
      window.location.href = "/";
    }
    var data = JSON.parse(localStorage.getItem("userrights"));
    var res = data.filter(
      (val) =>
        val.screenName == this.UserRightsConfiguration.CUSTOMER_BULK_CREDIT
    );
    if (!res[0].isView) {
      window.location.href = "/store/dashboard";
    }
    this.setState({ userRights: res });
  }

  columns = [
    {
      title: labels.FILE_NAME,
      dataIndex: "fileName",
      key: "fileName",
      sorter: true,
    },
    {
      title: labels.TOTAL_RECORDS,
      dataIndex: "totalCnt",
      key: "totalCnt",
      sorter: true,
    },
    {
      title: labels.UPLOADED_BY,
      dataIndex: "createdByName",
      key: "createdByName",
      sorter: true,
    },
    {
      title: labels.UPLOADED_ON,
      dataIndex: "createdOn",
      key: "createdOn",
      sorter: true,
      render: (text) => {
        return [null, undefined, ""].includes(text)
          ? ""
          : moment(text).format("DD-MM-YYYY hh:mm:ss a");
      },
    },
    {
      title: labels.SUCCEEDED,
      dataIndex: "succeeded",
      key: "succeeded",
      sorter: true,
      render: (text, record, index) => {
        return (
          <Space direction="horizontal">
            <span>{text}</span>
            <Tooltip title={labels.DOWNLOAD}>
              <Button
                onClick={() =>
                  this.getReport(record.custCreditFileID, true)
                }
                type="link"
              >
                <FontAwesomeIcon icon={faDownload} />
              </Button>
            </Tooltip>
          </Space>
        );
      },
    },
    {
      title: labels.FAILED,
      dataIndex: "failed",
      key: "failed",
      sorter: true,
      render: (text, record, index) => {
        return (
          <Space direction="horizontal">
            <span>{text}</span>
            <Tooltip title={labels.DOWNLOAD}>
              <Button
                onClick={() =>
                  this.getReport(record.custCreditFileID, false)
                }
                type="link"
              >
                <FontAwesomeIcon icon={faDownload} />
              </Button>
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  componentDidMount() {
    const { pagination } = this.state;
    this.fetchItems({
      custCreditFileID: this.state.custCreditFileID,
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      pagination,
    });
  }

  handleSearch = (event) => {
    this.fetchItems({
      custCreditFileID: this.state.custCreditFileID,
      commonSearch: event.target.value,
      pageIndex: this.state.pagination.current,
      pageSize: this.state.pagination.pageSize,
      pagination: this.state.pagination,
      // ...filters,
    });
  };

  getReport = (id, type) => {
    this.customerbulkCreditService
      .getReport({
        custCreditFileID: parseInt(id),
        isSucceeded: type,
      })
      .then((response) => {
        
        this.setState(
          {
            excelFile: (
              <div>
                <ExcelFile
                  hideElement={true}
                  filename={type ? "succeeded" : "failed"}
                >
                  <ExcelSheet
                    data={response.data}
                    name={type ? "Succeeded Records" : "Failed Records"}
                    columns={[]}
                  >
                    <ExcelColumn label="Customer Name" value="customerName" />
                     <ExcelColumn label="MobileNo" value="mobileNo" />
                     {/* <ExcelColumn label="CreatedBy" value="createdBy" />  */}
                     <ExcelColumn label="CreatedBy Name" value="createdByName" /> 
                     <ExcelColumn label="Created On" value="createdOn" /> 
                     <ExcelColumn label="Bonus Amount" value="bonusAmount" /> 
                     <ExcelColumn label="lkCashBlc" value="lkCashBlc" /> 
                     <ExcelColumn label="lkCreditBlc" value="lkCreditBlc" /> 
                     <ExcelColumn label="Admin Remark" value="adminRemark" /> 
                     <ExcelColumn label="Customer Remark" value="customerRemark" /> 
                    <ExcelColumn
                      label="Validity (In Days)"
                      value="validityInDays"
                    />
                    <ExcelColumn label="Remarks" value="remark" /> 
                  </ExcelSheet>
                </ExcelFile>
              </div>
            ),
          },
          () => this.setState({ excelFile: <React.Fragment></React.Fragment> })
        );
      });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.fetchItems({
      custCreditFileID: 0,
      pageIndex: pagination.current,
      pageSize: pagination.pageSize,
      pagination,
      sortColumn: sorter.field,
      sortOrder:
        sorter.order === "ascend"
          ? "asc"
          : sorter.order === "descend"
          ? "desc"
          : sorter.order,
      // ...filters,
    });
  };

  handlePopupOk = () => {
    this.setState({ showAddPopup: false });
  };

  handlePopupCancel = () => {
    this.setState({ showAddPopup: false });
    this.resetFields();
  };

  fetchItems = (params = {}) => {
    this.setState({ loading: true });
    this.customerbulkCreditService
      .getcustomerbulkcreditdata(params)
      .then((items) => {
        if (items.statusCode === 200) {
          if (
            items.length !== 0 &&
            items.data.length === 0 &&
            params.pagination.current !== 1
          ) {
            params.pagination.current = 1;
            this.fetchItems({
              custCreditFileID: 0,
              pageIndex: 1,
              pageSize: params.pageSize,
              pagination: params.pagination,
            });
          }
          this.setState({
            lkCustomerBulkCreditItems: items.data,
            pagination: {
              ...params.pagination,
              total:
                items.length !== 0 && items.data.length !== 0
                  ? items.data[0].totalRecords
                  : 0,
            },
          });
        } else {
          notification["error"]({
            message: labels.CUSTOMER_BULK_CREDIT,
            description: items.message
              ? this.common.Message(items.message)
              : labels.UNABLE_TO_GET_LIST_OF_CUSTOMER_BULK_CREDIT_DATA,
          });
        }
        this.setState({ loading: false });
      });
  };

  handleSingleCredit = (values) => {
    this.setState({ modalLoading: true });
    // Same five fields as the spreadsheet, sent straight to the server, which
    // re-validates and then runs the identical credit + SMS/push path.
    let postData = {
      mobileNo: (values.mobileNo || "").trim(),
      bonusAmount: String(values.bonusAmount).trim(),
      validityInDays: String(values.validityInDays).trim(),
      customerRemark: (values.customerRemark || "").trim(),
      adminRemark: (values.adminRemark || "").trim(),
    };
    this.customerbulkCreditService.saveSingleCredit(postData).then((response) => {
      if (response.statusCode === 200) {
        notification["success"]({
          message: labels.CUSTOMER_BULK_CREDIT,
          description: this.common.Message(response.message),
        });
        this.setState({ showSinglePopup: false });
        this.fetchItems({
          pageIndex: this.state.pagination.current,
          pageSize: this.state.pagination.pageSize,
          ...this.state.pagination,
        });
      } else {
        // Left open on failure so the entered values are not lost.
        notification["error"]({
          message: labels.CUSTOMER_BULK_CREDIT,
          description: response.message
            ? this.common.Message(response.message)
            : labels.UNABLE_TO_UPLOAD_THE_FILE,
        });
      }
      this.setState({ modalLoading: false });
    });
  };

  handleUpload = (values) => {
    this.setState({ modalLoading: true });
    let postData = new FormData();
    postData.append("CustomerBulkCreditFile", values.file[0].originFileObj);
    this.customerbulkCreditService.uploadFile(postData).then((response) => {
      
      if (response.statusCode === 200) {
        notification["success"]({
          message: labels.CUSTOMER_BULK_CREDIT,
          description: this.common.Message(response.message),
        });
        this.fetchItems({
          pageIndex: this.state.pagination.current,
          pageSize: this.state.pagination.pageSize,
          ...this.state.pagination,
        });
      } else {
        notification["error"]({
          message: labels.CUSTOMER_BULK_CREDIT,
          description: response.message
            ? this.common.Message(response.message)
            : labels.UNABLE_TO_UPLOAD_THE_FILE,
        });
      }
      this.setState({ modalLoading: false });
    });
    this.setState({ showAddPopup: false });
  };

  handleBonusAmount = (e) => {
    this.setState({ bonusAmount: e.target.value });
  };

  handleDateChange = (date, name) => {
    this.setState({ [name]: date });
  };

  handleRemark = (e) => {
    this.setState({ remark: e.target.value });
  };

  resetFields = () => {
    this.setState({
      custCreditFileID: 0,
      fileName: "",
      totalCnt: "",
      succeeded: "",
      failed: "",
      isEnabled: false,
      isVisible: false,
    });
  };

  render() {
    const {
      fileName,
      totalCnt,
      succeeded,
      failed,
      pagination,
      loading,
      remark,
    } = this.state;
    const lkCustomerBulkCreditItems = this.state.lkCustomerBulkCreditItems;
   
    let RegexInteger = /^[1-9]+[0-9]*$/g;
    const listItems = lkCustomerBulkCreditItems.map((item, index) => ({
      key: item.custCreditFileID,
      custCreditFileID: item.custCreditFileID,
      fileName: item.fileName,
      totalCnt: item.totalCnt,
      succeeded: item.succeeded,
      failed: item.failed,
      totalRecords: item.totalRecords,
      createdBy: item.createdBy,
      createdByName: item.createdByName,
      createdOn: item.createdOn,
    }));
    return (
      <div>
         {this.state.excelFile}
        <PageHeader
          title={labels.CUSTOMER_BULK_CREDIT}
          extra={[
            <Search
              placeholder={labels.SEARCH}
              className={styles.SearchInput}
              onChange={this.handleSearch}
              key="1"
            />,
            <a
              href={window.location.origin + "/files/CustomerBulkCredit.xlsx"}
              key="4"
              style={{ alignSelf: "center" }}
            >
              {labels.DOWNLOAD_FORMAT}
            </a>,
            this.state.userRights.length > 0 &&
            this.state.userRights[0].isAdd == true ? (
              <Button
                variant="transparentGreyOutline"
                onClick={() => this.setState({ showSinglePopup: true })}
                key="3"
              >
                Add Single Credit
              </Button>
            ) : null,
            this.state.userRights.length > 0 &&
            this.state.userRights[0].isAdd == true ? (
              <Button
                variant="purple"
                htmlType="submit"
                onClick={() => this.setState({ showAddPopup: true })}
                key="2"
              >
                {labels.UPLOAD_FILE}
              </Button>
            ) : null,
          ]}
        />
        <Table
          size="small"
          columns={this.columns}
            dataSource={listItems}
            pagination={pagination}
            loading={loading}
            onChange={this.handleTableChange}
        />
        <TableActions isPagination={true}></TableActions>
        <Modal
          title={
            this.state.custCreditFileID === 0
              ? labels.ADD_CUSTOMER_BULK_CREDIT
              : this.state.isEnabled
              ? labels.VIEW_CUSTOMER_BULK_CREDIT
              : labels.EDIT_CUSTOMER_BULK_CREDIT
          }
          visible={this.state.showAddPopup}
          footer={null}
          onCancel={this.handlePopupCancel}
          className="modal-form"
          destroyOnClose
        >
          <Spin spinning={this.state.modalLoading}>
            <Form
              layout="vertical"
              onFinish={this.handleUpload}
              initialValues={{
                fileName,
                totalCnt,
                succeeded,
                failed,
              }}
            >
              <Row gutter={24}>
                <Col xs={24}>
                  <Form.Item
                    name="file"
                    label={
                      labels.UPLOAD_CUSTOMER_BULK_CREDIT_CONFIGURATION_FILE
                    }
                    rules={[
                      { required: true, message: labels.PLEASE_SELECT_FILE },
                    ]}
                    valuePropName="fileList"
                    getValueFromEvent={(e) => {
                      if (Array.isArray(e)) {
                        return e;
                      }
                      return e && e.fileList;
                    }}
                  >
                    <Upload
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.xls"
                      customRequest={({ onSuccess }) => {
                        setTimeout(() => {
                          onSuccess("ok");
                        }, 0);
                      }}
                    >
                      <Button variant="transparentGreyOutline">
                        <UploadOutlined /> {labels.CLICK_TO_UPLOAD}
                      </Button>
                    </Upload>
                  </Form.Item>
                </Col>

                <Col xs={24} className="custom-modal-footer">
                  <Space>
                    {this.state.isVisible ? (
                      <>
                        <Button
                          variant="transparentGreyOutline"
                          onClick={this.handlePopupCancel}
                        >
                          {labels.CANCEL}
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          variant="transparentGreyOutline"
                          onClick={this.handlePopupCancel}
                        >
                          {labels.CANCEL}
                        </Button>
                        <Button htmlType="submit" variant="purple">
                          {this.state.custCreditFileID === 0
                            ? labels.ADD
                            : labels.UPDATE}
                        </Button>
                      </>
                    )}
                  </Space>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
        <Modal
          title="Add Single Credit"
          visible={this.state.showSinglePopup}
          footer={null}
          onCancel={() => this.setState({ showSinglePopup: false })}
          className="modal-form"
          destroyOnClose
        >
          <Spin spinning={this.state.modalLoading}>
            <Form layout="vertical" onFinish={this.handleSingleCredit}>
              <Row gutter={24}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="mobileNo"
                    label="Mobile No."
                    rules={[
                      { required: true, message: "Please enter Mobile No." },
                      {
                        pattern: /^[0-9]{10}$/,
                        message: "Mobile No. must be exactly 10 digits",
                      },
                    ]}
                  >
                    <Input maxLength={10} placeholder="10 digit mobile number" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="bonusAmount"
                    label={labels.BONUS_AMOUNT}
                    rules={[
                      {
                        required: true,
                        message: labels.PLEASE_ENTER_BONUS_AMOUNT,
                      },
                      {
                        validator: (_, value) =>
                          value === undefined ||
                          value === null ||
                          String(value).trim() === "" ||
                          (!isNaN(Number(value)) && Number(value) > 0)
                            ? Promise.resolve()
                            : Promise.reject(
                                new Error(
                                  "Bonus Amount must be a number greater than 0"
                                )
                              ),
                      },
                    ]}
                  >
                    <Input placeholder="e.g. 150.00" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="validityInDays"
                    label="Validity (In Days)"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Validity (In Days)",
                      },
                      {
                        validator: (_, value) =>
                          value === undefined ||
                          value === null ||
                          String(value).trim() === "" ||
                          (/^[0-9]+$/.test(String(value).trim()) &&
                            Number(value) > 0)
                            ? Promise.resolve()
                            : Promise.reject(
                                new Error(
                                  "Validity must be a whole number greater than 0"
                                )
                              ),
                      },
                    ]}
                  >
                    <Input placeholder="e.g. 90" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="customerRemark"
                    label="Customer Remark"
                    rules={[
                      { required: true, message: "Please enter Customer Remark" },
                    ]}
                  >
                    <Input placeholder="Shown to the customer in the SMS" />
                  </Form.Item>
                </Col>
                <Col xs={24}>
                  <Form.Item name="adminRemark" label="Admin Remark">
                    <Input placeholder="Internal note (optional)" />
                  </Form.Item>
                </Col>
                <Col xs={24} className="custom-modal-footer">
                  <Space>
                    <Button
                      variant="transparentGreyOutline"
                      onClick={() => this.setState({ showSinglePopup: false })}
                    >
                      {labels.CANCEL}
                    </Button>
                    <Button htmlType="submit" variant="purple">
                      {labels.ADD}
                    </Button>
                  </Space>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      </div>
    );
  }
}
